import React from "react";

export default (props: { [key: string]: any }) => <>{JSON.stringify(props)}</>;
